module.exports = new __parcel__URL__("twsanomaly-globe.d4ec0aab.png").toString();